 <template>
    <div class="games">
      <div class="container page_banner game_banner ">
        <div class='page_width'>
         <div class="banner_gruop" v-animate="'animate__animated animate__slideInDown'">
            <div class="banner_title">GAMES</div>
            <!-- <div class="banner_tips">Step into the game and start your journey!</div> -->
         </div>
        </div>
      </div>
      
      <div class="container cate_container" > 
        <div class="page_width  ">
          <div class="page_title" v-animate="'animate__animated animate__lightSpeedInLeft'">
          <div class="title_name">Our Games</div>
          <!-- <div class="title_info">Our team is a dynamic blend of creative minds and tech innovators united by a passion for gaming. From visionary designers to skilled coders, we collaborate to craft immersive worlds that captivate players worldwide. With a focus on innovation and storytel</div> -->
        </div>
         
        </div>
         <div class="page_thumb " v-for="(item,index) in games" :key="index" :class="[item.id==2||item.id==4?'bg_one':'']">
          <div class="page_width  ">
            <div class="page_container game_container"> 
              <div class="grid grid_md_gap grid_gap_none">
                <div class="grid_md_6 grid_xs_6 grid_sm_12"  >
                  <div class="item_group">
                    <div class="item_inner " >
                      <div class="item_img" v-animate="'animate__animated animate__rotateIn'" @click="toGame(item)">
                        <img :src="item.icon" alt="">    
                      </div>
                     
                    </div>
                  </div>
                </div>
                 <div class="grid_md_6 grid_xs_6 grid_sm_12"  >
                  <div class="item_group">
                    <div class="item_inner " :class="[item.id==2||item.id==4?'':'']">
                     
                      <div class="group_half flex_flex_sb">
                        <div class="half_container" v-animate="'animate__animated animate__rotateInDownLeft'">
                          <div class="half_title color3">{{ item.title }}</div>
                          <div class="half_text color1" style="margin-top:20px;">{{ item.msg }}</div>
                        </div>
                        
                        <div class="btn_group flex" style="margin-top:30px;" :class="[item.id==2||item.id==4?'':'']">
                          <div class="btn pointer color2 flex_center" @click="toPage('/payment')"  v-if="item.status==1" style="margin-right:20px;"><span class="bg_btn btn_inner" >GAME TOP UP</span></div>
                          <a href="https://apps.apple.com/us/app/galaxy-chaos-survivors/id6757690874" target="_blank"><div class="btn pointer" v-if="item.status==1"><img src="../../assets/image/apple.png" alt="" ></div></a>
                          <div class="pointer color2 flex_center"  v-if="item.status==0"><span class="bg_btn btn_inner" style="padding:10px 20px">Under development</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
      </div>
      
      

  
      

    

    
    
    </div>
  
  </template>
  
  <script>
  import { swiper, swiperSlide,} from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  export default {
    components: {
      swiper,
      swiperSlide,
      
    },
    data () {
      return {
        tabId:'',
        screenWidth: document.body.clientWidth,
        swiperOption: {},
        swiperOption2:{},
      
       
      }
    },
    created () {
      this.setOptions()
      // this.setOptions2()
    },
    methods: {
      setOptions(){
        this.swiperOption = {
          loop: false,
          autoplay: false,
          // slidesPerView:5,
          // centeredSlides : true,
          spaceBetween: 0,
          observer:true,  //修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,  //修改swiper的父元素时，自动初始化swiper
          observeSlideChildren:true,
          pagination:{
            el:'.swiper-pagination',
            clickable:true
          },
        }
     
      },
      setOptions2(){
        this.swiperOption2 = {
          loop: false,
          autoplay: false,
          // slidesPerView:5,
          // centeredSlides : true,
          spaceBetween: 0,
          observer:true,  //修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,  //修改swiper的父元素时，自动初始化swiper
          observeSlideChildren:true,
          pagination:{
            el:'.swiper-pagination2',
            clickable:true,
            bulletActiveClass: 'my-bullet-active',
          },
        }
     
      },
      collapseItem(id){
        let tabId = this.tabId
        if(tabId == id){
          this.tabId = 0
          return
        }
        this.tabId = id
      },
  
      windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 0){
        this.$store.state.isFloat = true
      }else{
        this.$store.state.isFloat = false
      }
      },
      toPage(path){
       
        this.$router.push(path)
      },
      toGame(item){
        if(item.url){
          window.open(item.url)
        }
      }
  
      
      
    },
    mounted () {
      window.onresize = () => {
        this.screenWidth = window.innerWidth
      },
      window.addEventListener('scroll', this.windowScroll);
      
    },
    computed:{
     
      mySwiper(){
        return this.$refs.mySwiper.swiper
      },
      mySwiper2(){
        return this.$refs.mySwiper2.swiper
      },
      games(){ return this.$store.state.games }
    },
    watch: {
      // "$store.state.page": {
      //   handler: function (newVal) {
      //     this.name = newVal
      
      //   }
      // },
      
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.windowScroll);
    },
  
  
    
  }
  </script>
  <style lang='scss' scoped>
  .games {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color:#fff;
    margin-top:-80px;
  
    .page_top{
      margin-top:80px;
    }
   .game_container{
    position: relative;
    // &::before{
    //   content:'';
     
    //   width: 1px;
    //   background:#14DF86;
    //   position: absolute;
    //   left:50%;
    //   top:20px;
    //   bottom:20px;
    // }
   }
   .item_img{
    // width: 45%;
   }
   .page_thumb{
    padding:80px 0;
    position: relative;
    z-index: 1;
    &::before{
      content: url(../../assets/image/fk_1.png);
      left: 40px;
      top:-20px;
      position: absolute;
      z-index: -1;
    }
    &::after{
      content: url(../../assets/image/fk_2.png);
      right: 40px;
      top:20px;
      position: absolute;
      z-index: -1;
    }
   }
   .bg_one{
    background: #000B40;
   }
    .item_group{
      height: 100%;
      width: 100%;
      padding: 40px 0;
      .item_inner{
        position: relative;
        text-align: left;
       
      }
      @media screen and (max-width : 767px){
        .half_title{
          font-size: 18px!important;
        }
        .half_text{
          font-size: 14px!important;
        }
      }
      .flex_reve{
        flex-direction: row-reverse;
        text-align: right!important;
      }

    .group_half{
    
      .min_title{
          color:$theme_color3;
          font-size:40px;
          margin-bottom:20px;
          text-align: left;
        }
      .half_container{
        margin-bottom:30px;
        .half_title{
          font-size: 30px;
          color:$theme_color4;
          margin-bottom:20px;
        }
        .half_msg{
          font-size: 24px;
          margin-top:10px;
          color:$theme_color1;
        }
        .half_text{
          font-size: 20px;
          color:$theme_color8;
          font-weight: 300;
          font-family: PingFang SC, PingFang SC;
        }
      }
      
      .half_title_group{
        color:$theme_color2;
        text-align: left;
        .title_h{
          font-size: 48px;
        }
        .title_p{
          font-family: PingFang SC, PingFang SC;
          font-size:22px;
          color:$theme_color1;
          text-align: left;
          
        }
      }
      .half_content{
        text-align: left;
        .content_group{
          width: 50%;
          .half_title{
            color:$theme_color1;
            font-size: 80px;
          }
          .half_text{
            font-size: 16px;
            font-weight: 800;
            font-family: PingFang SC, PingFang SC;
            color:$theme_color3;
          }
        }
        
      }
      
      
    }
   
      
    }
   
   
    
    .cate_container{
      padding:50px 0 20px; 
    }
  
    
   
   
  
   
  }
 
  </style>
  <style lang="scss">

 
  </style>